import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { useSelector } from 'react-redux'
import { RootState } from '../rootState'

import { Suggestion } from '../../types/Suggestion'

const initialState = {
  suggestions: [],
}

interface SuggestState {
  suggestions: Suggestion[]
}

const slice = createSlice({
  name: 'suggestion',
  initialState,
  reducers: {
    setSuggestions: (
      state: SuggestState,
      action: PayloadAction<Suggestion[]>
    ) => {
      state.suggestions = action.payload
    },
    remove: (state: SuggestState, action: PayloadAction<string>) => {
      state.suggestions = state.suggestions.filter(
        (e) => e.id !== action.payload
      )
    },
  },
})

export const useSuggestions = (): Suggestion[] =>
  useSelector((state: RootState) => state.suggestion.suggestions)

export const SUGGESTION_STORE_NAME = slice.name
export const SuggestionActions = slice.actions
export default slice.reducer
